var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-qr-code"},[_vm._t("default",[_c('div',[_vm._v(" 手机作图 ")])]),_c('img',{staticClass:"qr-code",attrs:{"src":require("../../assets/qr-code.svg"),"draggable":"false"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }